/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomDdlKey } from './customDdlKey';


export interface CustomDdl { 
    /**
     * The internal Id that uniquely references the newly created custom DDL
     */
    id?: number;
    customDdlKey: CustomDdlKey;
    /**
     * A container for the custom DDL code
     */
    ddl: string;
}
